var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bulkAction)?_c('BulkActionTasksTable',{model:{value:(_vm.bulkAction),callback:function ($$v) {_vm.bulkAction=$$v},expression:"bulkAction"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }